import React, { useRef } from "react";
import videoSrc from "../assets/videos/video-background-home.mp4";
import HomePropertySearchForm from "./HomePropertySearchForm";

export default function VideoBackground() {
  const videoRef = useRef(null);

  return (
      <div
          className="relative h-screen w-full overflow-hidden"
      >
        <video
            ref={videoRef}
            className="absolute top-0 left-0 w-full h-full object-cover"
            src={videoSrc}
            loop
            muted
            playsInline
            autoPlay
        />

        <div className="relative flex items-center justify-center h-full bg-darkGray bg-opacity-65">
          <div className="relative flex flex-col justify-center items-center h-full w-full">
            <h1 className="md:hidden title text-center">
              Live<br />the luxury.
            </h1>
            <h2 className="hidden md:block title text-center">
              Live the luxury.
            </h2>
            <span className="sub-title mt-[18px] md:mt-[20px]">
              FEEL BETTER.
            </span>
            <div className="hidden md:block absolute md:bottom-[40px] px-[110px] w-full md:px-[60px] sm:px-[20px]">
              <HomePropertySearchForm />
            </div>
          </div>
        </div>
      </div>
  );
}
